module.exports = __webpack_public_path__ + "static/media/girl-19.bd0acffb.svg";